module.exports = __webpack_public_path__ + "static/media/team-member-06.202bec2a.jpg";